// import node module libraries
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

// import custom components
import GKAccordionBox from 'components/marketing/common/accordions/GKAccordionBox';

// Import Loading Animation
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

// import data files
//import { MostAskedFAQs } from 'data/marketing/help-center/HelpCenterFAQsData';

const HelpCenterFAQs = () => {
	const { t } = useTranslation(); // useTranslation-Hook
	const [MostAskedFAQs, setMostAskedFAQs] = useState([]);
	const [isLoadingMostAskedFAQs, setIsLoadingMostAskedFAQs] = useState(true);

	const authHeader = useAuthHeader();
	// fetch data from api
	const options = {
		params: {

		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	const getData = async () => {
		setIsLoadingMostAskedFAQs(true);

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.get(`${baseURL}/public/faqs?faq_categories=mostasked`, options)
			.then(response => {
				const responseData = response.data.data; // Extract the data from the response
				setMostAskedFAQs(
					responseData
						? responseData.map(item => ({
							id: item.id,
							title: item.faq_title,
							content: item.faq_content
						}))
						: []
				); // Map the data to match the expected keys
				setIsLoadingMostAskedFAQs(false);
			})
			.catch((error) => {
				setIsLoadingMostAskedFAQs(false);
			});
	}

	useEffect(() => {
		getData();
	}, []);

	return (
		<section className="py-lg-16 py-10">
			<Container>
				<Row>
					<Col lg={{ offset: 2, span: 6 }} xs={12}>
						<div className="mb-8 pe-lg-14">
							<h2 className="pe-lg-12 mb-4 h1 fw-semi-bold">
								{t('Most asked questions (FAQ)')}
							</h2>
							<p className="lead">
								{t('We have compiled the most frequently asked questions for you in an FAQ.')}
								<Link to="/marketing/help-center/faq/" className="ms-1">
									{t('Open all FAQs')} <i className="fe fe-arrow-right"></i>
								</Link>
							</p>
						</div>
					</Col>
				</Row>
				<Row>
					<Col lg={{ offset: 2, span: 8 }} xs={12}>
						{isLoadingMostAskedFAQs || MostAskedFAQs && MostAskedFAQs.length == 0 ? (
							<Skeleton height="40px" count={8} />
						) : (
							MostAskedFAQs && MostAskedFAQs.length > 0 && (
								<GKAccordionBox accordionItems={MostAskedFAQs} itemClass="px-0" />
							)
						)}

					</Col>
				</Row>
			</Container>
		</section>
	);
};
export default HelpCenterFAQs;
